angular.module('dpw.directives')
    .directive('dpwNewFooter', ['helpers', 'newFooterService', 'menuService', function (helpers, newFooterService, menuService) {
        return {
            restrict: 'A',
            replace: true,
            scope: true,
            controller: [function () {
                var self = this;
                self._footerNavigationGroup = newFooterService.footerNavigationGroup;
                self.iconLink = newFooterService.iconLink;
                self.textLink = newFooterService.textLink;

                Object.defineProperty(this, 'footerNavigationGroup', {
                    set: function (resolvedNavigationGroup) {
                        self._footerNavigationGroup = resolvedNavigationGroup;
                    },
                    get: function () {
                        return self._footerNavigationGroup;
                    }
                });

                self.$onInit = function () {
                    resolveFooterNavigationGroup();
                };

                self.onClick = function (event, item) {
                    if (item.onClick) {
                        item.onClick(event);
                    }
                };

                self.onTextLinkClick = function(event, item) {
                    if (item.onClick) {
                        var res = item.onClick();

                        if (!res) {
                            event.preventDefault();
                        }
                    }
                }

                self.getTargetAttr = function (menu) {
                    if (menu.target) {
                        return menu.target;
                    }
                    return helpers.isAbsoluteUrl(menu.href) ? '_blank' : '';
                };

                function resolveFooterNavigationGroup() {
                    var resolveNavigationGroup = self.footerNavigationGroup.map(function (navigationBlock) {
                        var menuGroup = (navigationBlock.content).map(function (menu) {
                            var item = {
                                label: menu.label,
                                href: menu.href,
                                target: menu.target,
                            };
                            menuService.resolveLink(item, 'Footer');
                            return item;
                        });

                        return {
                            title: navigationBlock.title,
                            content: menuGroup,
                        };
                    });
                    self.footerNavigationGroup = resolveNavigationGroup;
                }
            }],
            controllerAs: 'footerCtrl',
            templateUrl: 'dpw-new-footer.html'
        };
    }]);

